import { render, staticRenderFns } from "./FormEditarProveedor.vue?vue&type=template&id=7628d031&scoped=true&"
import script from "./FormEditarProveedor.vue?vue&type=script&lang=ts&"
export * from "./FormEditarProveedor.vue?vue&type=script&lang=ts&"
import style0 from "./FormEditarProveedor.vue?vue&type=style&index=0&id=7628d031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628d031",
  null
  
)

export default component.exports